"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractInvoicing = class UcContractInvoicing extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    labelCols;
    ux;
    dataMembers = ['labelCols', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelCols: 6,
                ux: null,
            },
        };
    }
    get item() {
        if (this.loaded) {
            return this.contract.invoicing;
        }
        return null;
    }
    get billingCycleName() {
        if (this.loaded) {
            return this.item.billing_cycle.split(' ')[1];
        }
        return null;
    }
    get billingCycleValue() {
        if (this.loaded) {
            return this.item.billing_cycle.split(' ')[0];
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_8742_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_8741_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_8320016629450276_showModal_8740_getActionArgs($event) {
        return {
            name: "ContractEditor",
            props: {
                target: "invoicing",
                contract: _.cloneDeep(this.contract),
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8738 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8737 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8738,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8737],
        });
        const act_8320016629450276_emit_8742 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_8742_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_close_8741 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_8742,
            event: "close",
            when: this.evh_8320016629450276_close_8741_getWhen,
            displayName: "emit",
        });
        const act_8320016629450276_showModal_8740 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_8740_getActionArgs,
            events: [evh_8320016629450276_close_8741],
        });
        const evh_8320016629450276_clickPreventStop_8739 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_8740,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_8739],
        });
        return {
            act_7315092382398562_reloadComponentData_8738,
            evh_7315092382398562_reload_8737,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_8742,
            evh_8320016629450276_close_8741,
            act_8320016629450276_showModal_8740,
            evh_8320016629450276_clickPreventStop_8739,
            evh_8320016629450276_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractInvoicing.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractInvoicing.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractInvoicing.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractInvoicing.prototype, "onReadonly", null);
UcContractInvoicing = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractInvoicing);
exports.default = UcContractInvoicing;
vue_property_decorator_1.Vue.component("UcContractInvoicing", UcContractInvoicing);
